<template>
  <div>
    <div class="user-form">
      <div class="success-title">{{ $t("lang.userPage50") }}</div>
      <img src="~assets/images/sorry.png" class="success-img" />
      <div class="countdown">{{ $t("lang.userPage51") }}</div>
      <div class="btn" @click="_sendActivateEmial">
        {{ $t("lang.userPage52") }}
      </div>
    </div>
    <div class="app-bg"></div>
  </div>
</template>
<script>
import { sendActivateEmial } from "api/me";
import { ERR_OK } from "api/config";

export default {
  data() {
    return {
      emailParma: {
        email: decodeURIComponent(this.$route.query.email)
      }
    };
  },
  methods: {
    _sendActivateEmial() {
      if (this.emailParma.email !== 'undefined') {
        sendActivateEmial(this.emailParma)
          .then(response => {
            if (response.status !== 200) {
              this.$message.error(response.data.message);
            } else {
              if (response.data.code === ERR_OK) {
                this.$message.success(this.$t("lang.userPage53"));
              } else {
                this.$message.error(response.data.message);
              }
            }
          })
          .catch(() => {});
      } else {
        this.$message.error(this.$t("lang.userPage54"));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.user-form {
  width: 998px;
  height: 498px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -250px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
}
.success-title {
  margin: 30px 0px 50px;
  font-size: 18px;
  color: $gray;
  text-align: center;
}
.success-img {
  display: block;
  width: 219px;
  height: 201px;
  margin: 20px auto;
}
.btn {
  width: 300px;
  margin: 0 auto;
}
.countdown {
  text-align: center;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/me/user-activate-failure.vue